/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * <p>
 * Copyright © 2019 Pearson Education, Inc.
 * All Rights Reserved.
 * <p>
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 *
 * This is the data class for holding partner attributes.
 *
 * @author urahish
 * 01/09/2020
 *
 */

import React, {useState} from 'react';
import EventEmitter from "../../../eventEmmiters/EventEmitter";
import Popup from "reactjs-popup";
import Icon from "../icon/Icon";
import './modalView.css';

const UrlViewer = (prop) => {
    const [openUrlViewer, setOpenUrlViewer] = useState(false);
    const [urlViewerData, setUrlViewerData] = useState({});

    const openUrlViewerModel = (data) => {
        setOpenUrlViewer(data)
    };
    EventEmitter.on('openUrlViewer', openUrlViewerModel);

    const setModelData = (data) => {
        setUrlViewerData(data)
    };
    EventEmitter.on('urlViewerData', setModelData);

    const closeUrlViewer = () => {
        setOpenUrlViewer(false);
    };

    let modalContent = null;
    if (urlViewerData !== undefined) {
        if (urlViewerData.data !== '')
            modalContent =
                <div className="column-container">
                    <textarea value={urlViewerData.data} disabled={true}/>
                </div>;
        else
            modalContent = <h5>No Data to display</h5>;
    } else
        modalContent = <h5>No Data to display</h5>;

    return(
        <Popup open={openUrlViewer} onClose={closeUrlViewer}>
            <div>
                <button style={{position: 'absolute',top: 0, right: 0}} className="pe-icon--btn static-close-title"
                        onClick={() => closeUrlViewer()}
                        aria-label="Close warning">
                    <Icon name="remove-sm-24"/>
                </button>
                {modalContent}
            </div>
        </Popup>
    );
};
export default UrlViewer;
